import { render, staticRenderFns } from "./AwardDetails.vue?vue&type=template&id=16a7771e&"
import script from "./AwardDetails.vue?vue&type=script&lang=js&"
export * from "./AwardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a7771e')) {
      api.createRecord('16a7771e', component.options)
    } else {
      api.reload('16a7771e', component.options)
    }
    module.hot.accept("./AwardDetails.vue?vue&type=template&id=16a7771e&", function () {
      api.rerender('16a7771e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/AwardDetails.vue"
export default component.exports